import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import 'swiper/css';
import 'swiper/css/navigation';
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { get_categorias } from "../../redux/actions/home";

const breakpoints = {
    300: { slidesPerView: 2, spaceBetween: 5 },
    400: { slidesPerView: 2, spaceBetween: 5 },
    640: { slidesPerView: 3, spaceBetween: 10 },
    768: { slidesPerView: 3, spaceBetween: 10 },
    992: { slidesPerView: 4, spaceBetween: 15 },
    1200: { slidesPerView: 6, spaceBetween: 15 },
    1400: { slidesPerView: 6, spaceBetween: 20 },
};

function CategoryImage({ categories }) {
    const navigationPrevRef = React.useRef(null);
    const navigationNextRef = React.useRef(null);

    return (
        <>
            <div className="relative container-fluid" style={{ marginTop: "-40px" }}>
                <div className="relative container px-1 md:px-4">
                    {/* Flechas de navegación */}
                    <div ref={navigationPrevRef} className="hidden md:flex absolute left-[-2rem] top-1/2 transform -translate-y-1/2 z-10">
                        <button className="h-10 w-10 bg-brand-blue hover:bg-blue-700 transition-colors duration-300 rounded-full text-white flex justify-center items-center shadow-lg">
                            <FontAwesomeIcon icon={faAngleLeft} className="text-xl" />
                        </button>
                    </div>

                    <div ref={navigationNextRef} className="hidden md:flex absolute right-[-2rem] top-1/2 transform -translate-y-1/2 z-10">
                        <button className="h-10 w-10 bg-brand-blue hover:bg-blue-700 transition-colors duration-300 rounded-full text-white flex justify-center items-center shadow-lg">
                            <FontAwesomeIcon icon={faAngleRight} className="text-xl" />
                        </button>
                    </div>

                    {/* Swiper */}
                    <Swiper
                        breakpoints={breakpoints}
                        spaceBetween={10}
                        navigation={{
                            prevEl: navigationPrevRef.current,
                            nextEl: navigationNextRef.current,
                        }}
                        onBeforeInit={(swiper) => {
                            swiper.params.navigation.prevEl = navigationPrevRef.current;
                            swiper.params.navigation.nextEl = navigationNextRef.current;
                        }}
                        modules={[Navigation]}
                        className="mySwiper text-center p-2 pb-3"
                    >
                        {
                            categories.map((category, index) => (

                                <SwiperSlide key={index}>
                                    <Link to={`/categoria/${category.slug}`} className='no-underline'>
                                        <div className="text-center rounded-lg shadow-md border p-3 transform transition-transform duration-300 hover:scale-105">
                                            <div className="min-h-[40px]">
                                                <p className="text-sm font-medium mb-0 text-black">  {category.name}</p>
                                            </div>
                                            <img
                                                src={category.image}
                                                alt={category.name}
                                                className="w-full object-cover aspect-[1/1] mb-2 p-4"
                                            />
                                            <div className="" >
                                                    <button className="bg-blue-100 text-brand-blue px-4 py-1 rounded-2 text-xs fw-medium w-100">Ver productos</button>
                                            </div>

                                        </div>
                                    </Link>
                                </SwiperSlide>
                            ))}
                    </Swiper>
                </div>
            </div>

        </>
    );
}


const mapStateToProps = state => ({
    categories: state.Home.categories

})

export default connect(mapStateToProps, {
})(CategoryImage)